
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class BrnnTable extends Vue {
    //百人牛牛
    table = {
        data: [],
        column: [
            {
                key: 'dealer',
                title: ' 庄(投注+牌型)',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.dealer) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.dealer.bet)
                    }
                    let poker = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point.dealer.poker
                    }
                    return h('div', [
                        h(
                            'p',
                            {
                                style: {
                                    color: 'red',
                                    height: '20px'
                                }
                            },
                            str
                        ),
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'heart',
                title: '天(投注+牌型)',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.heart) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.heart.bet)
                    }
                    let poker = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point.heart.poker
                    }
                    return h('div', [
                        h(
                            'p',
                            {
                                style: {
                                    color: 'red',
                                    height: '20px'
                                }
                            },
                            str
                        ),
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'diamond',
                title: '地(投注+牌型)',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.diamond) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.diamond.bet)
                    }
                    let poker = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point.diamond.poker
                    }
                    return h('div', [
                        h(
                            'p',
                            {
                                style: {
                                    color: 'red',
                                    height: '20px'
                                }
                            },
                            str
                        ),
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'club',
                title: '玄(投注+牌型)',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.club) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.club.bet)
                    }
                    let poker = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point.club.poker
                    }
                    return h('div', [
                        h(
                            'p',
                            {
                                style: {
                                    color: 'red',
                                    height: '20px'
                                }
                            },
                            str
                        ),
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'spade',
                title: '黄(投注+牌型)',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.spade) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.spade.bet)
                    }
                    let poker = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point.spade.poker
                    }
                    return h('div', [
                        h(
                            'p',
                            {
                                style: {
                                    color: 'red',
                                    height: '20px'
                                }
                            },
                            str
                        ),
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'total_bet',
                title: '总投注',
                align: 'center',
                render: (h, params) => {
                    let str = 0
                    if (JSON.parse(params.row.opt_detail).hits.hits.spade) {
                        str += (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.spade.bet, 1)
                    }
                    if (JSON.parse(params.row.opt_detail).hits.hits.club) {
                        str += (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.club.bet, 1)
                    }
                    if (JSON.parse(params.row.opt_detail).hits.hits.diamond) {
                        str += (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.diamond.bet, 1)
                    }
                    if (JSON.parse(params.row.opt_detail).hits.hits.heart) {
                        str += (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.heart.bet, 1)
                    }
                    return h('span', str.toFixed(2))
                }
            },
            {
                key: 'black',
                title: '总返奖',
                align: 'center',
                render: (h, params) => {
                    let str = (this as any).getMoney(params.row.chang_point)
                    let color = '#333'
                    if (str > 0) {
                        color = 'red'
                    } else if (str < 0) {
                        color = 'blue'
                    }
                    return h(
                        'span',
                        {
                            style: {
                                color: color
                            }
                        },
                        str
                    )
                }
            }
        ]
    }

    @Prop()
    listdata
}
